import styled from 'styled-components';

export const BreadcrumbText = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
    cursor: pointer;
`;

export const BreadcrumbSeparator = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
`;

export const FolderName = styled.span`
    padding-left: 1rem;
    cursor: pointer;
`;
